import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ClientPlugin from './plugins/client.js'
import LoadingPlugin from './plugins/loading.js'
import VueMasonry from 'vue-masonry-css'

Vue.use(VueMasonry)
Vue.use(ClientPlugin)
Vue.use(LoadingPlugin)

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFacebookF,
  faTwitter,
  faInstagram
} from '@fortawesome/free-brands-svg-icons'

import {
  faBars,
  faMouse,
  faTimes,
  faHome,
  faMobileAlt,
  faMapMarkerAlt,
  faAt,
  faHourglassStart,
  faTrash,
  faPen,
  faPlus,
  faCaretDown,
  faCouch,
  faCheck,
  faSave,
  faUpload,
  faExclamation
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faFacebookF,
  faTwitter,
  faInstagram,
  faBars,
  faMouse,
  faTimes,
  faHome,
  faMobileAlt,
  faMapMarkerAlt,
  faAt,
  faHourglassStart,
  faTrash,
  faPen,
  faPlus,
  faCaretDown,
  faCouch,
  faCheck,
  faSave,
  faUpload,
  faExclamation
)

Vue.component('fa-icon', FontAwesomeIcon)
Vue.component('UiProduct', () => import('./components/ui/product.vue'))
Vue.component('UiCategorie', () => import('./components/ui/category.vue'))
Vue.component('UiDevider', () => import('./components/ui/devider.vue'))

import '@/assets/styles/app.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
